import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react-lite';
import styled from 'styled-components';

import { Colours, Sizes, Typography } from '@ratehub/base-ui';


function CardFeeSummaryContainer({ children, ...otherProps }) {
    return (
        <MyFeeSummary {...otherProps}>
            {children}
        </MyFeeSummary>
    );
}

CardFeeSummaryContainer.propTypes = {
    children: PropTypes.node.isRequired,
};


const MyFeeSummary = styled.dl`
    /* we expect this outer-most container to end with a separator which has 0.5rem margin, so
       here we need to add only 1rem to meet our standardized 1.5rem bottom margin */
    margin: 0 0 ${Sizes.SPACING.ONE} 0;

    ${({ marginBottom }) => marginBottom && `margin-bottom: ${marginBottom};`}

    display: -ms-grid;
    -ms-grid-columns: 1fr max-content;
    -ms-grid-rows: auto;

    display: grid;
    grid-template-columns: 1fr max-content;
    grid-template-rows: auto;
    align-items: center;

    .row1 { -ms-grid-row: 1; }
    .row2 { -ms-grid-row: 2; }
    .row3 { -ms-grid-row: 3; }
    .row4 { -ms-grid-row: 4; }
    .row5 { -ms-grid-row: 5; }
`;

CardFeeSummaryContainer.Description = styled.dt`
    -ms-grid-column: 1;

    font-weight: ${Typography.WEIGHTS.MEDIUM};
    font-size: ${Sizes.FONTS.S};
    padding: ${Sizes.SPACING.HALF} 0;

    & > small {
        font-size: ${Sizes.FONTS.XS};
        font-weight: ${Typography.WEIGHTS.REGULAR};

        b {
            font-weight: ${Typography.WEIGHTS.MEDIUM};
        }
    }
`;

CardFeeSummaryContainer.Value = styled.dd`
    -ms-grid-column: 2;
    margin-left: ${Sizes.SPACING.ONE};

    & > output {
        font-weight: ${Typography.WEIGHTS.MEDIUM};
        font-size: ${Sizes.FONTS.XS};
        padding: ${Sizes.SPACING.HALF} 0;
    }
`;

CardFeeSummaryContainer.Separator = styled.div`
    -ms-grid-column-span: 2;
    grid-column: 1 / -1;

    width: 100%;
    border-top: 1px solid ${Colours.STONE};
    margin: ${Sizes.SPACING.HALF} 0;
`;

export default observer(CardFeeSummaryContainer);
